import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20gradient%20with%20soft%20rose%20and%20gold%20tones%2C%20flowing%20artistic%20textures%2C%20minimalist%20luxurious%20aesthetic%2C%20dreamy%20smooth%20composition%2C%20warm%20romantic%20atmosphere&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始探索了吗？
        </h2>
        <p className="text-base md:text-lg text-white/75 mb-8 max-w-lg mx-auto leading-relaxed">
          加入数百万用户的大家庭，发现属于您的独家精彩内容。品质保证，安全稳定，持续更新。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/exclusive"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-base"
          >
            立即开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap text-base border border-white/30"
          >
            了解品牌故事
          </Link>
        </div>
      </div>
    </section>
  );
}